<template>
  <v-layout align-center justify-center>
    <v-flex v-if="vendor && vendor.VendorDetails[0].terms === 'No'" xs12 sm6 md4 lg3>
      <v-card class="elevation-12" align-center justify-center>
        <v-toolbar dark color="primary">
          <v-toolbar-title>TERMS & CONDITIONS</v-toolbar-title>
        </v-toolbar>
        <v-card xs12 class="d-flex justify-center pa-4">
          <v-img
            src="/static/img/logo.png"
            max-width="250"
          ></v-img>
        </v-card>
        <v-card-text>
          <div class="text-xs-center">
            <p>By clicking "ACCEPT" below, you acknowledge that you have received a copy of the Elizabeth Stampede
              Vendor Handbook and that you have read and agree to the Terms & Conditions and Liability Waiver. You can click the buttons
              below to review each of the documents (a PDF will open in a separate window).</p>
            <p>After you ACCEPT the Terms & Conditions, you will have access to make a PAYMENT and to review/update
              your contact information.</p>

            <v-btn :href="terms" target="_blank" color="primary">View Terms</v-btn>
            <v-btn :href="handbook" target="_blank" color="primary">View Handbook</v-btn>
            <v-btn :href="waiver" target="_blank" color="primary">View Waiver</v-btn>
          </div>

          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-text-field
              name="name"
              label="Name"
              id="name"
              v-model="name"
              :rules="[v => !!v || 'Name is required']"
              required
              @input="$v.name.$touch()"
              @blur="$v.name.$touch()"
            ></v-text-field>
            <v-text-field
              name="title"
              label="Title"
              id="title"
              v-model="title"
              :rules="[v => !!v || 'Title is required']"
              required
              @input="$v.title.$touch()"
              @blur="$v.title.$touch()"
            ></v-text-field>
            <v-text-field
              name="email"
              label="Email"
              type="email"
              v-model="email"
              :rules="emailRules"
              required
              @input="$v.email.$touch()"
              @blur="$v.email.$touch()"
            ></v-text-field>
          </v-form>
          <v-alert :value="error" type="warning" transition="scale-transition">
            <span v-html="error"></span>
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="cancel">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="accept">Accept</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-flex v-else-if="vendor" xs12 lg8>
      <InternalForm
        :visible="showForm"
        :item="vendor"
        :key="vendor.id"
        :currentYear="currentYear"
        persistent
      />
    </v-flex>
    <v-flex v-else xs12 sm6 md4 lg3>
      <v-card class="elevation-12" align-center justify-center>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Vendor Login</v-toolbar-title>
        </v-toolbar>
        <v-card xs12 class="d-flex justify-center pa-4">
          <v-img
            src="/static/img/logo.png"
            max-width="250"
          ></v-img>
        </v-card>
        <v-card-text>
          <v-form>
            <v-text-field
              prepend-icon="email"
              name="email"
              label="Email"
              type="email"
              v-model="email"
              :error-messages="emailErrors"
              @input="$v.email.$touch()"
              @blur="$v.email.$touch()"
              @keyup.enter="login"
            ></v-text-field>
            <v-text-field
              :append-icon="showpassword ? 'visibility_off' : 'visibility'"
              prepend-icon="lock"
              name="password"
              label="Password"
              id="password"
              :type="showpassword ? 'text' : 'password'"
              v-model="password"
              :error-messages="passwordErrors"
              @input="$v.password.$touch()"
              @blur="$v.password.$touch()"
              @keyup.enter="login"
              @click:append="() => (showpassword = !showpassword)"
            ></v-text-field>
          </v-form>
          <v-alert :value="error" type="warning" transition="scale-transition">
            <span v-html="error"></span>
          </v-alert>

          <div class="text-xs-center">
            <p><strong>Attention: All activities are logged!</strong></p>
            <p>If you have already registered or your company has been at the Elizabeth Stampede, please login. If you have issues logging in please contact vendors@elizabethstampede.com.</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="login">Login</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import moment from 'moment'
import InternalForm from './vendorExtern/InternalForm.vue'

export default {
  mixins: [validationMixin],

  validations: {
    email: { required, email },
    password: { required },
    name: { required },
    title: { required }
  },

  components: {
    InternalForm
  },

  data () {
    return {
      terms: process.env.API_URL + '/vendor/Vendor_Terms_and_Conditions.pdf',
      handbook: process.env.API_URL + '/vendor/Vendor_Handbook_and_TsCs.pdf',
      waiver: process.env.API_URL + '/vendor/Liability_Waiver.pdf',
      showForm: false,
      showpassword: false,
      email: '',
      password: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      error: null,
      currentYear: 0,
      vendor: null,
      ip: '',
      name: '',
      title: ''
    }
  },

  created () {
    if (this.$session.get('vendor')) {
      this.vendor = this.$session.get('vendor')
      this.currentYear = this.$session.get('currentYear')
    }

    this.getIp()
  },

  computed: {
    nameErrors () {
      const errors = []
      if (!this.$v.name.$dirty) return errors
      !this.$v.name.required && errors.push('Name is required.')
      return errors
    },
    titleErrors () {
      const errors = []
      if (!this.$v.title.$dirty) return errors
      !this.$v.title.required && errors.push('Title is required.')
      return errors
    },
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Must be valid e-mail')
      !this.$v.email.required && errors.push('E-mail is required')
      return errors
    },
    passwordErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Password is required.')
      return errors
    }
  },

  methods: {
    cancel () {
      console.log('test1')
      this.currentYear = 0
      this.vendor = null
      this.email = ''
      this.password = ''
    },

    async login () {
      this.$v.$touch()

      try {
        let currentDate = moment().format('YYYY-MM-DD')
        let theDate = moment().toObject()

        if (currentDate >= theDate.years + '-07-01') {
          this.currentYear = theDate.years + 1
        } else {
          this.currentYear = theDate.years
        }

        console.log(this.currentYear)

        const response = await Api().post('vendor_login/', {
          email: this.email,
          password: this.password,
          year: this.currentYear,
          ip: this.ip
        })

        this.vendor = response.data.vendor

        this.$session.start()
        this.$session.set('vendor', response.data.vendor)
        this.$session.set('currentYear', this.currentYear)

        this.password = ''
      } catch (error) {
        this.email = ''
        this.password = ''
        // this.currentYear = 0
        console.log('test2')

        this.error = error.response.data.error
      }
    },

    async getIp () {
      fetch('https://api.ipify.org?format=json')
        .then(x => x.json())
        .then(({ ip }) => {
          this.ip = ip
        })
    },

    async accept () {
      try {
        let terms = {}
        terms.id = this.vendor.id
        terms.name = this.name
        terms.title = this.title
        terms.email = this.email

        if (this.$refs.form.validate()) {
          await Api().put('extern_vendor_terms/' + this.vendor.VendorDetails[0].id, terms)
          this.vendor.VendorDetails[0].terms = 'Yes'
        } else {
          this.snackbar.message = 'You have some errors on the page!'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      } catch (error) {
        this.error = error.response.data.error
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/VendorLogin.vue